<template>
  <div class="details-reader-array">
    <div class="details-reader__row">
      <div
        v-for="(item) in data"
        :key="`${item.name}-${item.association}`"
      >
        <span class="details-reader-array__item">
          {{ item.name }}: {{ item.association }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/*
model
[{ association name }]
*/
export default {
  name: 'verification-details-pep-info-associates',
  components: {},
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
